import ScrollControl from "./scrollcontrol";
import ModuleBase, { moduleInit, ViewLayer, implementFunction } from "../../../../framework/core/mvvm/module_base";
import CustomerServiceView from "./customer_service_view";
import ModelBase from "../../../../framework/core/mvvm/model_base";
import CustomerServiceUtil, { ICustomConvertionReq } from "./customer_service_util";
import EventManager from "../../../../manager/event_manager";
import { Notify } from "../../server/notify/proto_notify";

const {ccclass, property} = cc._decorator;

export enum ContentTypeEnum{
    text = 1,//文本     
    img = 2,//图片
    voice = 3,//语音

    wait = 101,//等待消息
    start_greet = 102,//会话开始
    end_greet=103,//会话结束
    user_end_greet=104,//客户会话结束信息
    time_out_warning=105,//会话超时警告
    time_out_end_greet=106,//会话超时结束信息
    custom_greet=107,//客服问候语
    offLine_greet=108,//离线会话问候语
    plaer_cancel_order=109,//玩家取消订单
    order_audit_finish=110,//订单审核完成
    bank_info=200,//银商银行信息
    bank_order_greet=201, //银商重置订单问候语
    bank_order_detail=202,//银商重置订单详情
    
}
@ccclass
@moduleInit("CustomerService")
export default class CustomerService extends ModuleBase<CustomerServiceView, null> {

    
    _model: ModelBase = new ModelBase()
    _lastPinTime: number = 0
    protected LastSendChatTime: number = 0
    curType=0
    curCustomId=-1
    pageNum=1
    pageSize=50
    curCid:string=""
    readyMsg:string=""
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/hall/module/customer_service/customer_service';
        this.viewType = CustomerServiceView;
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = true;
        
        this.needViewBaseCloseBtn = true
        
    }
    
    onInit()
    {
        this.view.closeBtn.node.on('click', this.onClick_btnClose, this);
        this.view.sendBtn.node.on('click', this.onClick_send, this);
        this.eventBind("Event_Notify_Customer_Chat_Data",this.getChatMsg.bind(this))
    }
    private onClick_btnClose() {
        // Utility.playButtonSound()
        this.hide()
    }
    onClick_send()
    {
        if(this.view.inputTxt.placeholder=="")
        {
            return
        }
        this.sendChat(this.view.inputTxt.placeholder)

    }
    onShow(arg0) {

        
        this.curType=arg0["type"]
        
        this.view.scrollControl.setInitData(this.data)
        return;
        CustomerServiceUtil.isCreateConversation(this.curType,this.isCreateConversationSuccess.bind(this),this.isCreateConversationFail.bind(this),this)
        this.eventBind("send_problemId", this.sendtNormalProblem)
        this.eventBind("showAnwer", this.addAnwerItem)
        this.eventBind("sendMsgSuccess", this.sendMsgSuccess)
        
    }

//================================================================================
    //返回是否创建会话
    isCreateConversationSuccess(data:any)
    {
        this.view.scrollControl.setInitData(this.data)
        return
        if(data.isCreate) //已经创建
        {
            CustomerServiceUtil.queryChatHistoryPage(this.curType,this.pageNum,this.pageSize,this.getChatHistoryPageSuccess.bind(this),this.getChatHistoryPageFail.bind(this),this)
        }
        else //未创建 先获取咨询类型 
        {
            CustomerServiceUtil.getProblemType(this.getProblemTypeSuccess.bind(this),this.getProblemTypeFail.bind(this),this)
        }
    }
    isCreateConversationFail()
    {

    }
//================================================================================
    //获取聊天记录
    getChatHistoryPageSuccess(data:any)
    {
        // cc.log(data)
        // for(let i=0;i<data.list.length;i++)
        // {
        //     cc.log(data.list[i]["content"])
        // }
       
    }
    getChatHistoryPageFail(data:any)
    {

    }
//================================================================================

    //发送常见问题
    sendtNormalProblem(id:string)
    {
        if(id=="online_custom")
        {
       
            let req:ICustomConvertionReq={
                    //银商id 银商会话时使用
                problemTypeCode: "online_custom",     //问题类型编码
                customType: 1 ,         //会话类型(1-系统会话 2-银商会话 3-游客会话)
              
            }
            CustomerServiceUtil.getNewCustomConvertion(req,this.getNewCustomConvertionSuccess.bind(this),this.getNewCustomConvertionFail.bind(this),this)
            return
        
        }
        CustomerServiceUtil.getCustomProblem(id.toString(),this.getProblemAnswerSuccess.bind(this),this.getProblemAnswerFail.bind(this),this)
    }

    addAnwerItem(txt:string)
    {
        this.view.scrollControl.addAnwerItem(txt)
    }
//================================================================================

    //获取咨询类型
    getProblemTypeSuccess(data:any[])
    {
        cc.log(data)
        
        data[0].createTime=this.view.timeMgr.addNewTodayTime(data[0].createTime)
        
        
        this.view.scrollControl.setProblemType(data)
    }
    getProblemTypeFail(data:any)
    {
        
    }
//================================================================================
    //获取常见问题回复
    getProblemAnswerSuccess(data:any[])
    {
        
        this.view.scrollControl.setProblemList(data)
        
        
    }
    getProblemAnswerFail()
    {
        
    }
//========================================================
    //发送消息
    sendChat(txt:string)
    {
        if(this.curCid=="" || this.view.inputTxt.placeholder=="")
        {
            return
        }
        this.readyMsg=txt;
        CustomerServiceUtil.sendChat(1,this.curCid,txt,this.sendChatSuccess.bind(this),this.sendChatFail.bind(this),this)
        //this.content.active=true
        //this.scrollControl.scrollView.scrollToBottom()
        //cc.log(this.scrollControl.content.childrenCount)

        
    }
    sendChatSuccess(data:any)
    {
        EventManager.instance.dispatch("sendMsgSuccess",this.readyMsg)
    }
    sendChatFail()
    {

    }
    sendMsgSuccess(bbb:any)
    {
        let data:any={}
        data.content=this.readyMsg
        data.type=1
        this.view.scrollControl.addItem(data)
    }
//===========================================================
   //获取新会话
   getNewCustomConvertionSuccess(data:any)
   {
        this.curCid=data.cid
        this.curCustomId=data.customId
   }
   getNewCustomConvertionFail()
   {

   }

   getChatMsg(chatMsg:Notify.ChatMessage)
   {
       //cc.log(chatMsg.content.)
       let msgJson=JSON.parse(chatMsg.content)
       cc.log(msgJson.contentType)
        let data:any={}
        data.type=msgJson.fromType
        if(msgJson.contentType==ContentTypeEnum.end_greet) //小文本显示
        {

        }
        else if(msgJson.contentType==ContentTypeEnum.img) //显示图片
        {

        }
        else if(msgJson.contentType==ContentTypeEnum.voice) //语音
        {

        }
        else //正常文本
        {
            data.content=msgJson.data
        }
        this.view.scrollControl.addItem(data)
       
        // switch(chatMsg.content["contentType"])
        // let data:any={}
        // data.type=2
        // data.context

   }

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}
    data = [
        
        {
            type: 1,
            content: '0一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '1遗忘，那些琐碎的一切。迷惘，在自己的世界。',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '2一起做个的毒虫。',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '3用麻醉自己。',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '4用称作的针头',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '5注射和',
            time: '8月30日 1:37'
        },
        
        {
            type: 1,
            content: '6磨碎中下阶级的粉末，化成高纯度的上流',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '7渴望金字塔顶端的堕落，的你和我。',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '8的你和我。',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '9拜金主义',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '10拜金主义',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '11拜金主义',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '12拜金主义的毒虫——！',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '13拜金主义',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '14拜金主义',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '15拜金主义',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '16拜金主义毒虫',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '17烧吧，升起糜烂的烟。抽吧，吐出全身的疲惫。',
            time: '8月30日 1:37'
        },
        
        {
            type: 2,
            content: '18谢谢观赏',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '19上面的文字摘自一首摇滚歌曲《毒虫》，创作乐队：老破麻',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '20emmmm...我觉得写的很好，唱的也很好。',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '21墙裂推荐！！！',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '22嗯，老破麻是一支台湾乐队，目前还很小众。',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '23但绝对是宝藏乐队',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '24是的没错，他们的风格囊括了金属核甚至是',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '25张亚东老师的一句经典台词：非常好',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '26好了，我们说一下这个组件',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '27说毛线，有毛线好说啊，那么简单谁不会用啊！',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '28okok...',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '29有问题可以去我们团队的Github提',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '30链接：',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '31团你妹夫！就一破组件还团队呢我去',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '32。。。',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '33别戳穿我嘛',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '34我tm',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '35我希望这个组件大家用了之后会觉得',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '36我跟你说就你这破组件吃枣药丸',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '37狗头保命',
            time: '8月30日 1:37'
        },
        {
            type: 1,
            content: '38走你',
            time: '8月30日 1:37'
        },
        {
            type: 2,
            content: '39再见了您嘞',
            time: '8月30日 1:37'
        },
    ];
    start () {
        
        //this.scrollControl.setInitData(this.data);
        //this.sendBtn.node.on('click', this.sendClick, this)

    }
   
    // update (dt) {}
}
